/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointSaveProgressStore" />
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { StoreBase } from "DistributedTask/Flux/Store";
import { EndpointsEditorActionsHub } from "../Actions/EndpointsEditorActionsHub";
import { EndpointSaveStatus } from "../Components/EndpointsEditorPanelInterfaces";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ActionsCreatorInstanceIds } from "../Constants";

interface IEndpointSaveProgressStoreState {
    isSaveInProgress: boolean;
}

export namespace EndpointSaveProgressStoreEvents {
    export const Started = "SAVE_STARTED";
    export const Succeeded = "SAVE_SUCCEEDED";
    export const Failed = "SAVE_FAILED";
    export const Completed = "SAVE_COMPLETED";
}

export class EndpointSaveProgressStore extends StoreBase {

    private readonly _state: IEndpointSaveProgressStoreState;
    private readonly _actions: EndpointsEditorActionsHub;

    constructor() {
        super("");

        this._actions = ActionsHubManager.GetActionsHub<EndpointsEditorActionsHub>(EndpointsEditorActionsHub);
        this._actions.updateSaveProgress.addListener(this._updateSaveProgress);

        this._state = {
            isSaveInProgress: false
        };
    }

    public static getKey(): string {
        return "endpoint-save-progress-store";
    }

    protected disposeInternal(): void {
        this._actions.updateSaveProgress.removeListener(this._updateSaveProgress);
    }

    private _updateSaveProgress = (status: EndpointSaveStatus) => {

        const isSaveInProgress = !!(status.saveInProgress || status.setupInProgress || status.verifyInProgress);

        if (isSaveInProgress === this._state.isSaveInProgress) {
            return;
        }

        let event = "";

        if (!this._state.isSaveInProgress && isSaveInProgress) {
            event = EndpointSaveProgressStoreEvents.Started;
        }
        else if (status.errorMessage) {
            event = EndpointSaveProgressStoreEvents.Failed;
        }
        else {
            event = EndpointSaveProgressStoreEvents.Succeeded;
        }

        this._state.isSaveInProgress = isSaveInProgress;
        this.emit(event, this);

        if (!isSaveInProgress) {
            this.emit(EndpointSaveProgressStoreEvents.Completed, this);
        }
    }
}

export function createEndpointSaveProgressStore(): EndpointSaveProgressStore {
    const guid = (crypto as any).randomUUID();
    const instanceId = `${ActionsCreatorInstanceIds.EndpointSaveProgressStoreInstanceId}-${guid}`;
    return StoreManager.GetStore(EndpointSaveProgressStore, instanceId);
}

export function deleteEndpointSaveProgressStore(store: EndpointSaveProgressStore): void {
    const instanceId = store.getInstanceId();
    return StoreManager.DeleteStore(EndpointSaveProgressStore, instanceId);
}